export { default as AndroidIcon } from './AndroidIcon';
